import { UserManager, WebStorageStateStore, User } from 'oidc-client';

export default class AuthService {
    private userManager: UserManager;

    constructor() {
        var redirectURI = process.env.VUE_APP_Base_URL + '/callback.html';
        var silentRedirectURI = process.env.VUE_APP_Base_URL + '/silent-renew.html';
        var logoutRedirectURI = process.env.VUE_APP_Base_URL;
        var language = localStorage.getItem("language");

        const settings: any = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: process.env.VUE_APP_OAUTH_SERVER,
            client_id: process.env.VUE_APP_OAUTH_CLIENT,
            redirect_uri: redirectURI,
            post_logout_redirect_uri: logoutRedirectURI,

            automaticSilentRenew: true,
            silent_redirect_uri: silentRedirectURI,

            response_type: 'id_token token',
            scope: 'openid profile role custom_profile vuejsAPI.read',
            accessTokenExpiringNotificationTime: 30,
            extraQueryParams: { lang: language },
            filterProtocolClaims: true,
        };

        this.userManager = new UserManager(settings);

        // helps to load and update the new user with metadata
        // this.userManager.events.addUserLoaded((args) => {
        //     var self = this.userManager;
        //     this.userManager.getUser().then((user) => {
        //         console.log(user);
        //     });
        // });

        // this.userManager.events.addSilentRenewError(e => {
        //     console.log("You are about to be signed out. Any unsaved changes will be lost.");
        // });

        // helps to force logout if the access token is expired
        // this.userManager.events.addAccessTokenExpired(e => {
        //     this.userManager.signoutRedirect();
        // });

        // this.userManager.events.addUserSignedOut(function () {
        //     alert("Logout");
        //     console.log('UserSignedOut：', arguments);
        //     //mgr.removeUser();  
        //     // this.userManager.signoutRedirect().then(function (resp) {
        //     //     console.log("signed out", resp);
        //     // }).catch(function (err) {
        //     //     console.log(err)
        //     // })
        // });
    }

    public getUser(): Promise<User | null> {
        return this.userManager.getUser();
    }

    public login(redirectUrl: string): Promise<void> {
        var language = localStorage.getItem("language") || "en-US";
        this.userManager.settings.extraQueryParams = { lang: language };

        if (redirectUrl) {
            var loginState = {};
            loginState["redirectUri"] = redirectUrl;

            return this.userManager.signinRedirect({ state: loginState });
        } else {
            return this.userManager.signinRedirect();
        }
    }

    public logout(): Promise<void> {
        if (sessionStorage.getItem("passwordNotify"))
            sessionStorage.removeItem("passwordNotify");
            
        return this.userManager.signoutRedirect();
    }

    public getAccessToken(): Promise<string> {
        return this.userManager.getUser().then((data: any) => {
            return data.access_token;
        });
    }

    public isLoggedIn(): Promise<boolean> {
        return this.userManager.getUser().then((data: any) => {
            return (data !== null && !data.expired);
        });
    }
}